import { render, staticRenderFns } from "./StuProveManage.vue?vue&type=template&id=07909a47&scoped=true&"
import script from "./stuprovemanage.js?vue&type=script&lang=js&"
export * from "./stuprovemanage.js?vue&type=script&lang=js&"
import style0 from "./StuProveManage.vue?vue&type=style&index=0&id=07909a47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07909a47",
  null
  
)

export default component.exports